
(function($) {

  $body = $('html,body');
  $anchors = $('.anchor-link');
  
  $anchors.click(function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $body.animate({scrollTop: $(aid).offset().top - 100}, 'slow');
  });

})(jQuery);